module.exports = __webpack_public_path__ + "static/masthead_bg_desktop-967bd3430e65fc101b9f3f8b8deebf7e.png";